export const LOYALTY_INFO = Symbol.for('LOYALTY_INFO');
